import React, { useEffect, useState } from 'react';

import { STATIC_ASSETS_URL } from 'constants/api';
import kebabCase from 'lodash-es/kebabCase';
import { Technology } from 'utils/products';

const DynamicMedicalDeviceLabel: React.FC = () => {
  const [srcDoc, setSrcDoc] = useState<string>('Loading...');

  useEffect(() => {
    const loadInjectedHTML = async () => {
      try {
        const version = Technology.version ?? '';
        const technology = kebabCase(Technology.availableTechnology ?? '');
        const clinicalStudySuffix = Technology.isClinicalStudy ? '-cs' : '';
        const response = await fetch(
          `${STATIC_ASSETS_URL}/labels/${version}/${technology}/${Technology.regionVariant}${clinicalStudySuffix}.html`,
        );
        const html = await response.text();
        setSrcDoc(html);
      } catch (error) {
        console.error('Failed to load medical label:', error);
        setSrcDoc(`<div style="color:red;">Failed to load content</div>`);
      }
    };

    void loadInjectedHTML();
  }, []);

  return (
    <iframe
      srcDoc={srcDoc}
      style={{
        width: '800px',
        height: '100px',
        border: 'none',
      }}
      title="Dynamic Label"
      sandbox="allow-scripts allow-same-origin"
    />
  );
};

export default DynamicMedicalDeviceLabel;
